














import Vue from "vue";
import { Option } from "./../types";
import { fetchGnfrMeta } from "@/services/meta";
import CustomDropdownSelector from "./CustomDropdownSelector.vue";
import LoadingAnimation from "./LoadingAnimation.vue";

export default Vue.extend({
  components: {
    CustomDropdownSelector,
    LoadingAnimation
  },
  data() {
    return {
      options: undefined as Option[] | undefined,
      initialOption: undefined as Option | undefined
    };
  },
  methods: {
    async loadGnfrOptions() {
      const gnfrOptions = await fetchGnfrMeta();
      if (!gnfrOptions) return;
      this.options = gnfrOptions.map((gnfr) => {
        return {
          id: gnfr.id,
          label: gnfr.name,
          value: gnfr,
          showFirst: gnfr.id === "COMBINED"
        } as Option;
      });
      this.initialOption = this.options.find((o) => o.id === "COMBINED");
    }
  },
  mounted() {
    this.loadGnfrOptions();
  },
  destroyed() {
    this.$emit("selected-gnfr", undefined);
  }
});
